<template>
  <div class="test">
    <div class="confirm-box">
      <div class="confirm-button">
        <div class="total-header">
          {{ conferenceBookingCreate.totalPriceText }}
        </div>
        <div class="submit-button-box-box">
          <div class="submit">
            <sc-button
              class="submit-button"
              variant="orange-cc"
              @click="handleBookingSubmit"
              v-if="!isAddressForm"
              >ยืนยันการจอง</sc-button
            >
          </div>
        </div>
      </div>
      <div class="confirm-detail">
        <div class="bold-detail mt-2 mb-2">รายละเอียดการจอง</div>
        <div class="date-selected">{{ conferenceBookingCreate.roomTitle }}</div>
        <div v-if="conferenceBookingCreate.createdAt">
          วันที่จอง: <span> {{ conferenceBookingCreate.createdAt }}</span>
        </div>
        <div class="mb-3 mt-3">
          <div
            v-for="(
              bookingDate, bookingDateIndex
            ) in conferenceBookingCreate.bookingDateList"
            :key="bookingDateIndex"
            class="booking-date mb-3"
          >
            <div class="booking-detail">
              <button
                class="button-toggle"
                @click="
                  handleChangeInput(
                    'isShow',
                    bookingDate.id,
                    !bookingDate.isShow
                  )
                "
              >
                <div class="header-booking-detail mb-2">
                  <div class="date-selected">
                    {{ bookingDate.date }}
                  </div>
                  <div class="arrow-detail"></div>
                </div>
                <div class="test">
                  <img
                    v-if="!bookingDate.isShow"
                    :src="'/static/icons/arrow-down-orange.svg'"
                    class="book-icon arrow"
                  />
                  <img
                    v-if="bookingDate.isShow"
                    :src="'/static/icons/arrow-up-orange.svg'"
                    class="book-icon arrow"
                  />
                </div>
              </button>
              <slide-up-down
                class="AccordionWrapper"
                :active="bookingDate.isShow"
                :duration="duration"
              >
                <div class="row mb-2">
                  <div class="col-5 left">ช่วงเวลา</div>
                  <div class="col-7 right">{{ bookingDate.timeDuration }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5 left">จำนวนผู้เข้าร่วม</div>
                  <div class="col-7 right">{{ bookingDate.numberOfPeople }} คน</div>
                </div>

                <div class="row mb-2">
                  <div class="col-5 left">ลักษณะการจัดห้อง</div>
                  <div class="col-7 right">
                    {{ bookingDate.pattern }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5 left">ลักษณะ package</div>
                  <div class="col-7 right">
                    {{ bookingDate.breakOption && bookingDate.breakOption.packageTitle || hyphenSymbol }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5 left">Coffee break</div>
                  <div
                    class="col-7 right"
                    v-if="
                      bookingDate.breakOption
                      && bookingDate.breakOption.breaks
                    "
                  >
                    <div
                      v-for="(breakBooking, breakBookingIndex) in bookingDate
                        .breakOption.breaks"
                      :key="breakBookingIndex"
                    >
                      <div>
                        <span class="serve-count"
                          >เซิฟ ({{ breakBookingIndex + 1 }}) /</span
                        >
                        {{ breakBooking.time }}
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-7 right">-</div>
                </div>
                <div
                  class="row mb-3"
                  v-if="
                    bookingDate.breakOption && bookingDate.breakOption.lunch
                  "
                >
                  <div class="col-5 left">Lunch break</div>
                  <div class="col-7 right">
                    {{ bookingDate.breakOption.lunch }}
                  </div>
                </div>
              </slide-up-down>
              <div class="price-detail mb-3"></div>

              <div class="row mb-3">
                <div class="col-5 left">ราคา</div>
                <div class="col-7 right">{{ bookingDate.priceText }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import SlideUpDown from "vue-slide-up-down";
import { hyphenSymbol, timeDurationDropdown } from "../VariableStatic";

export default {
  components: {
    "sc-button": ScButton,
    "slide-up-down": SlideUpDown,
  },
  props: ["value", "isAddressForm"],
  data() {
    return {
      conferenceBookingCreate: [],
      duration: 500,
      hyphenSymbol
    };
  },
  created() {
    this.setupConferenceBookingDetail();
  },
  watch: {
    duration() {
      this.duration = parseInt(this.duration);
    },
    value() {
      this.setupConferenceBookingDetail();
    }
  },
  methods: {
    async setupConferenceBookingDetail() {
      const conferenceBookingCreate = this.value;

      if (!conferenceBookingCreate) {
        this.conferenceBookingCreate = [];
        return;
      }

      this.conferenceBookingCreate = {
        ...conferenceBookingCreate,
        bookingDateList: conferenceBookingCreate.bookingDateList.map(
          (bookingDate) => {
            const timeDuration = timeDurationDropdown.find(
              (time) => time.value === bookingDate.timeDuration
            );

            return {
              ...bookingDate,
              isShow: true,
              timeDuration: timeDuration.label || "-",
            };
          }
        ),
      };
    },
    handleChangeInput(key, id, value) {
      const bookingDateList = this.conferenceBookingCreate.bookingDateList.map(
        (booking) => {
          return {
            ...booking,
            [key]: id === booking.id ? value : booking[key],
          };
        }
      );

      this.conferenceBookingCreate = {
        ...this.conferenceBookingCreate,
        bookingDateList,
      };
    },
    handleBookingSubmit() {
      this.$emit("handleBookingSubmit");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.test {
  background-color: $white;
  height: inherit;
}

.confirm-box {
  border: 2px solid $color-orange;
  border-radius: 5px;
  padding: 0;
}

.confirm-button {
  height: 65px;
  background-color: $color-light-orange-2;
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
}

.space-between,
.confirm-button {
  display: flex;
  justify-content: space-between;
}

.confirm-detail {
  padding-left: 15px;
  padding-right: 15px;
}

.submit-button {
  height: 35px;
}

.submit {
  padding-top: 13px;
}

.total-header {
  font-weight: bold;
  font-size: $font-22;
  color: $color-orange;
  padding-top: 15px;
}

.booking-date {
  border: 1px solid $color-light-gray-1;
  border-radius: 5px;
  height: inherit;
}

.right {
  text-align: right;
  font-weight: bold;
}

.price-detail {
  border: 1px solid $color-light-gray-1;
}

.price-detail,
.booking-detail {
  padding-left: 15px;
  padding-right: 15px;
}

.date-select {
  font-size: $font-20;
  font-weight: bold;
  color: $color-orange;
}

.button-toggle {
  width: 100%;
  border: 0;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: space-between;
  background-color: $white;
  padding-top: 10px;
  padding-bottom: 10px;
}

.date-selected {
  font-size: $font-22;
  font-weight: bold;
  color: $color-orange;
  border-radius: 5px;
}

button {
  padding: 0;
}

.test {
  padding-top: 4px;
}

.bold-detail {
  font-weight: bold;
  padding-top: 5px;
}

.left {
  font-size: $font-14;
}

@media screen and (max-width: $s-size) {
  .left {
    font-size: $font-14;
  }

  .right {
    font-weight: bold;
    font-size: $font-14 + 1;
  }
}

@media screen and (max-width: $sx-size) {
  .right {
    font-weight: bold;
    font-size: $font-12;
  }

  .left {
    font-size: $font-12;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/BookingConfirmBox.vue